import React, { useEffect, useRef, useState } from "react";
import H2 from "@/atoms/text/H2";
import H4 from "@/atoms/text/H4";
import Para from "@/atoms/text/Para";
import Image from "@/components/atoms/Image";
import Button from "@/atoms/Button";
import { isMobileScreen } from "@/utils/functions";
import PropTypes from "prop-types";

export default function IntegrationOneClick({ title, stepsData, image, cta }) {
  const [isMobile, setIsMobile] = useState(null);

  useEffect(() => {
    setIsMobile(isMobileScreen);
  }, []);

  const stepsRef = useRef(null);
  useEffect(() => {
    const updateSteps = () => {
      const steps = Array.from(stepsRef.current.children);
      const viewportCenter = window.scrollY - window.innerHeight / 2;

      steps.forEach((step) => {
        const stepCenter = step.offsetTop + step.offsetHeight / 2;
        if (stepCenter < viewportCenter) {
          step.classList.add("active");
        } else {
          step.classList.remove("active");
        }
      });
    };

    updateSteps();
    window.addEventListener("scroll", updateSteps);

    return () => window.removeEventListener("scroll", updateSteps);
  }, []);
  return (
    <section className="bc-grad-blue pv-15-d pv-8">
      <div className="container">
        <article className="fx-d fx--sb-d">
          <div className="w-50-d tc-white">
            <H2
              className="bold mb-7"
              color="white"
              dangerouslySetInnerHTML={{
                __html: `${title}<span class="dot">.</span>`,
              }}
            />
            <ul ref={stepsRef}>
              {stepsData.map((step) => (
                <li className="single-step ps-r" key={step.index}>
                  <div className="circle-wrapper text--mont bold">
                    {step.index}
                  </div>
                  <span className="dashed-line"></span>
                  <span className="fill-line"></span>
                  <H4
                    desktopSize="xs"
                    mobileSize="xxs"
                    color="white"
                    className="bold mb-1"
                    dangerouslySetInnerHTML={{ __html: step.title }}
                  />
                  <Para
                    color="white"
                    desktopSize="lg"
                    mobileSize="lg"
                    dangerouslySetInnerHTML={{ __html: step.content }}
                  />
                </li>
              ))}
            </ul>
            <div className={` ${isMobile ? "ta-center mb-8" : ""}`}>
              <Button href={cta} size="md" className="text--md" target="_blank">
                Activate on Zapier
              </Button>
            </div>
          </div>
          <Image
            fileName={image.fileName}
            desktopWidth={image.desktopWidth}
            mobileWidth={image.mobileWidth}
            alt={image.altText}
            fileFormat="png"
            imgStyle="m-center"
          />
        </article>
      </div>

      <style jsx>{`
        .single-step {
          padding: 0 0 60px 60px;
        }

        .single-step:last-child {
          padding: 0 0 40px 60px;
        }

        .single-step .circle-wrapper {
          width: 32px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          border-radius: 100%;
          -webkit-border-radius: 100%;
          position: absolute;
          left: 0;
          z-index: 1;
          outline: 2px solid #00aded;
          outline-offset: 4px;
          font-size: 20px;
          color: #00aded;
          transition: all 200ms ease;
        }

        .single-step.active .circle-wrapper {
          background-color: #00aded;
          color: #fff;
        }

        .single-step .dashed-line,
        .single-step .fill-line {
          width: 2px;
          position: absolute;
          top: 36px;
          left: 16px;
        }

        .single-step .dashed-line {
          height: calc(100% - 40px);
          background-image: linear-gradient(
            to bottom,
            #00aded 40%,
            transparent 0
          );
          background-size: 2px 8px;
          background-repeat: repeat-y;
        }

        .single-step .fill-line {
          border-left: 2px solid #00aded;
          height: 0;
        }

        .single-step:last-child .dashed-line,
        .single-step:last-child .fill-line {
          display: none;
        }

        .single-step.active .fill-line {
          animation: line_animation 200ms linear forwards;
        }

        @keyframes line_animation {
          0% {
            height: 0%;
          }

          100% {
            height: calc(100% - 40px);
          }
        }
      `}</style>
    </section>
  );
}

IntegrationOneClick.propTypes = {
  title: PropTypes.string,
  stepsData: PropTypes.arrayOf(
    PropTypes.shape({
      index: PropTypes.number,
      title: PropTypes.string,
      content: PropTypes.string,
    })
  ),
  image: PropTypes.shape({
    fileName: PropTypes.string,
    desktopWidth: PropTypes.number,
    mobileWidth: PropTypes.number,
    altText: PropTypes.string,
  }),
  cta: PropTypes.string,
};
